import { render, staticRenderFns } from "./view-collectionCode.vue?vue&type=template&id=7b10fa3c&"
import script from "./view-collectionCode.vue?vue&type=script&lang=ts&"
export * from "./view-collectionCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports